import {useContext} from 'react';
import {Modal, ModalContext} from '../context/Modal';

export function useModal(): Modal {
  const modalContext = useContext<Modal>(ModalContext);
  return modalContext;
}
